import router from "@/router";
import {Toast} from "vant";

export default {

  /**
   * 登录
   * @param state
   * @param data
   */
  login(state, data){
    Toast('登录成功');
    if(data && data.redirect){
      // 跳转到指定页面
      window.location.href = /\%3A\%2F\%2F/.test(data.redirect)?decodeURIComponent(data.redirect):data.redirect;
      return;
    }
    // 跳转到首页
    router.replace('/')
        .catch(err => console.warn(err));
  },

  /**
   * 切换tabbar显示
   * @param state
   * @param booleanVal
   */
  toggleTabbarShow(state, booleanVal){
    state.tabbarShow = booleanVal
  },

  /**
   * 页面请求失败值替换
   * @param state
   * @param data
   */
  setErrorShow(state, booleanVal) {
    state.errorShow = booleanVal
  },

  updateGlobalBg(state, data){
    state.globalBg = data;
  },

  /**
   * 更新服务对象列表
   * @param state
   * @param data
   */
  updateServiceObjects(state,data){
    state.serviceObjects = data
  },
  /**
   * 更新办理途径
   * @param state
   * @param data
   */
  updateServiceWays(state,data){
    state.serviceWays = data
  },
  /**
   * 更新事项类型
   * @param state
   * @param data
   */
  updateServiceTypes(state,data){
    state.serviceTypes = data
  },
  /**
   * 更新所属部门
   * @param state
   * @param data
   */
  updateServiceDepts(state,data){
    state.serviceDepts = data
  },
  /**
   * 更新服务筛选条件
   * @param state
   * @param data
   */
  updateServiceParams(state,data){
    state.serviceParams = data
  },
  /**
   * 更新事项清单服务对象
   * @param state
   * @param data
   */
  updateMatterObjects(state,data){
    state.matterObjects = data
  },
  /**
   * 更新事项清单事项性质
   * @param state
   * @param data
   */
  updateMatterNatures(state,data){
    state.matterNatures = data
  },
  /**
   * 更新事项清单办理模式
   * @param state
   * @param data
   */
  updateMatterModels(state,data){
    state.matterModels = data
  },
  /**
   * 更新事项清单部门机构
   * @param state
   * @param data
   */
  updateMatterDepts(state,data){
    state.matterDepts = data
  },
  /**
   * 更新事项清单筛选条件
   * @param state
   * @param data
   */
  updateMatterParams(state,data){
    state.matterParams = data;
  },
  /**
   * 更新设置字体大小
   * @param state
   * @param data
   */
  updateFont(state, data) {
    state.sizeNum = data;
    localStorage.setItem('sizeNum', data);
  }
};

